import { Injectable, inject, DOCUMENT } from '@angular/core';

import { LogService } from '../errors/log-service';

declare let gigya: any;
declare let window: {
  onGigyaServiceReady?: () => void;
};

@Injectable({
  providedIn: 'root',
})
export class GigyaUtils {
  private readonly logger = inject(LogService);
  private readonly document = inject(DOCUMENT);
  private sdkReadyPromise: Promise<void>;

  constructor() {
    this.sdkReadyPromise = new Promise((resolve) => {
      window.onGigyaServiceReady = () => {
        this.logger.log('Gigya SDK is ready (Global Service)');
        resolve();
      };
    });
  }

  public async runWhenReady(callback: () => void): Promise<void> {
    await this.sdkReadyPromise;
    callback();
  }

  public get isReady(): boolean {
    if (!gigya) return false;
    return gigya.isReady;
  }

  public setGigyaScreenSet(loginParams: ScreensetParams): void {
    gigya.accounts.showScreenSet(loginParams);
  }

  public hideScreenSet(containerID: string): void {
    const container = this.document.getElementById(containerID);
    if (container) {
      container.innerHTML = '';
    }
  }

  public getAccountInfo(params: any): void {
    gigya.accounts.getAccountInfo(params);
  }

  public hasSession(): Promise<boolean> {
    return gigya.hasSession();
  }

  public continue(): void {
    return gigya.sso.continue();
  }

  public initCLP(params: SSO_Login_params): void {
    gigya.sso.login(params);
  }

  public resendMail(
    regToken: string,
    callback?: Function,
    email?: string
  ): void {
    gigya.accounts.resendVerificationCode({ regToken, email, callback });
  }
}

export interface ScreensetParams {
  lang: string;
  screenSet: string;
  startScreen: string;
  containerID: string;
  sessionExpiration: number,
  onBeforeScreenLoad?: Function;
  onAfterSubmit?: Function;
}

export interface SSO_Login_params {
  authFlow: string;
  redirectURL: string;
}
